import { Text } from 'library';
import React from 'react';
import { Provider } from 'models';
import { Grid } from '@material-ui/core';

export default function PublicMessageHeader({ provider }: { provider: Provider }) {
    return (
        <Grid
            container
            item
            style={{
                paddingRight: 15,
                paddingLeft: 15,
                paddingBottom: 15,
                borderBottomWidth: 0.5,
                borderBottomColor: 'gray',
                borderBottomStyle: 'solid',
            }}
        >
            <Text variant="h1">Message {provider.user.first_name}</Text>
        </Grid>
    );
}
